<template>
  <BaseDropdown
    ref="dropdownRef"
    class="md:hidden"
    @on-change="handleDropdownChange"
    background-class="bg-surface-light"
  >
    <template #trigger>
      <span
        :class="[
          'bg-accent rounded-full items-center justify-center w-12 h-12 flex transition-colors border border-accent',
          open ? 'bg-white' : 'bg-accent',
        ]"
      >
        <ZoomFilterIcon v-if="!open" :class="['h-6 w-6', 'fill-accent-text']" />
        <CloseIcon v-else :class="['h-6 w-6', 'fill-accent']" />
        <span class="sr-only">
          {{ $t('globals.search') }}
        </span>
      </span>
    </template>

    <div class="-mx-4 pt-2 max-h-[calc(100dvh-120px)] overflow-y-auto">
      <BaseAccordion
        :open="openAccordion === 'categories'"
        @toggle="() => setAccordion('categories')"
      >
        <template #trigger>
          <span
            :class="[
              openAccordion && openAccordion !== 'categories'
                ? 'text-text'
                : '',
            ]"
          >
            {{ $t('globals.categories') }}
          </span>
        </template>
        <CategoryFilter @onChange="() => closeDropdownAndAccordion()" />
      </BaseAccordion>
      <BaseAccordion
        :open="openAccordion === 'locations'"
        @toggle="() => setAccordion('locations')"
      >
        <template #trigger>
          <span
            :class="[
              openAccordion && openAccordion !== 'locations' ? 'text-text' : '',
            ]"
          >
            {{ $t('globals.locations') }}
          </span>
        </template>
        <LocationFilter @on-change="() => closeDropdownAndAccordion()" />
      </BaseAccordion>
      <BaseAccordion
        :open="openAccordion === 'date'"
        @toggle="() => setAccordion('date')"
      >
        <template #trigger>
          <span
            :class="[
              openAccordion && openAccordion !== 'date' ? 'text-text' : '',
            ]"
          >
            {{ $t('globals.date') }}
          </span>
        </template>
        <DateFilter @on-change="() => closeDropdownAndAccordion()" />
      </BaseAccordion>
      <BaseAccordion
        :open="openAccordion === 'search'"
        @toggle="() => setAccordion('search')"
      >
        <template #trigger>
          <span
            :class="[
              openAccordion && openAccordion !== 'search' ? 'text-text' : '',
              openAccordion !== 'search' ? 'mb-2' : '',
            ]"
          >
            {{ $t('globals.search') }}
          </span>
        </template>
        <SearchFilter ref="searchRef" @on-enter="closeDropdownAndAccordion" />
      </BaseAccordion>
    </div>
  </BaseDropdown>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  import CategoryFilter from '../filters/CategoryFilter.vue';
  import DateFilter from '../filters/DateFilter.vue';
  import LocationFilter from '../filters/LocationFilter.vue';
  import SearchFilter from '../filters/SearchFilter.vue';
  import CloseIcon from '../icons/CloseIcon.vue';
  import ZoomFilterIcon from '../icons/ZoomFilterIcon.vue';
  import BaseAccordion from '../ui/BaseAccordion.vue';
  import BaseDropdown from '../ui/BaseDropdown.vue';

  const open = ref(false);
  const openAccordion = ref<string | null>(null);

  const dropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(null);
  const searchRef = ref<InstanceType<typeof SearchFilter> | null>(null);

  const handleDropdownChange = (val: boolean) => {
    open.value = val;
    if (!val) openAccordion.value = null;
  };

  function closeDropdownAndAccordion() {
    openAccordion.value = null;
    dropdownRef.value?.closeDropdown();
    open.value = false;
  }

  function setAccordion(type: string) {
    openAccordion.value = openAccordion.value === type ? null : type;

    if (openAccordion.value === 'search') {
      if (searchRef.value) {
        searchRef.value.clearInput();
        searchRef.value.focusInput();
      }
    }
  }
</script>
